import React from 'react'
import styled, { css } from 'styled-components'



export default ({ elem = "button", ...props }) => {

    const Component = styled(elem).attrs(passedProps => ({
        type: 'button',
        className: 'btn',
        ...passedProps,
        ...props
    }))`
        border: 2px var(--red) solid;
        appearance: none;
        padding: 0 1em;
        background-color: transparent;
        line-height: 40px;
        height: 39px;
        min-width: 142px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        color: var(--red);
        cursor: pointer;
        transition: background-color .2s ease, color .2s ease, border-color .2s ease;

        @media(hover: hover){
            &:hover {
                background-color: var(--darkred);
                border-color: var(--darkred);
                color: var(--white);
            }
        }

        ${props => props.primary && css`
            background-color: var(--red);
            color: var(--white);
        `}
    `


    return <Component />

}
